<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="footer">
        <lms-button :disabled="questionEdit" @click="save()" :loading="savingQuiz">Salvar</lms-button>
        <!-- <button class="btn btn-default" @click="saveVideos()">Salvar</button> -->
        <button class="btn btn-default" @click="close()">Cancelar</button>
      </div>
      <div slot="header" class="row">
        <h4 class="col-lg-12" style="padding:0px;">
          <label class="control-label">Nome da Avaliação:</label>
          <input style="width:100%;" type="text" v-model="quiz.title" />
        </h4>

        <div class="row">
          <div class="control-group col-lg-4">
            <label class="control-label">Nota mínima (porcentagem) *</label>

            <div class="controls">
              <div class="input-group">
                <input type="number" v-model="quiz.minimumScore" class="form-control" />
                <i class="fa fa-percent input-group-addon" aria-hidden="true"></i>
              </div>
            </div>

            <!-- <input style="width:100%;" type="text" v-model="quiz.minimumScore" /> -->
          </div>

          <div class="control-group col-lg-8">
            <label class="control-label" for="sexo">Módulo *</label>
            <select :disabled="modules.length == 0" class="form-control" v-model="quiz.moduleId">
              <option disabled value>Escolha um módulo</option>
              <option
                v-for="module in modules"
                v-bind:key="module.id"
                v-bind:value="module.id"
              >{{module.name}}</option>
            </select>
          </div>
        </div>
          <div class="row">
          <div class="control-group col-lg-6">
            <label class="control-label">Data de Início: </label>

            <div class="controls">
              <div class="input-group">
                <input type="datetime-local" v-model="quiz.startDate" class="form-control" />
                 <!-- <date-input class="form-control" v-model="quiz.startDate"></date-input> -->
                <i class="fa fa-calendar input-group-addon" aria-hidden="true"></i>
              </div>
            </div>

            <!-- <input style="width:100%;" type="text" v-model="quiz.minimumScore" /> -->
          </div>

          <div class="control-group col-lg-6">
            <label class="control-label">Data de Fim: </label>

            <div class="controls">
              <div class="input-group">
                <input type="datetime-local" v-model="quiz.endDate" class="form-control" />
                <i class="fa fa-calendar input-group-addon" aria-hidden="true"></i>
              </div>
            </div>

            <!-- <input style="width:100%;" type="text" v-model="quiz.minimumScore" /> -->
          </div>
        </div>
      </div>

      <div slot="body" style="margin:0px; margin-top: 20px !important;">
        <transition mode="out-in">
          <div v-if="questionEdit">
            <lms-button
              v-if="questionEdit.text && questionEdit.text.length > 0"
              @click="saveQuestion()"
              :loading="false"
            >
              <i class="fa fa-chevron-left"></i> Gravar
            </lms-button>

            <lms-button v-else @click="questionEdit=null;" :loading="false">
              <i class="fa fa-chevron-left"></i> Voltar
            </lms-button>

          <div style="display: inline-block;margin-left: 20px;">
            <label class="control-label">Tipo de questão: &nbsp</label>
            <select v-model="questionEdit.type" onChange="function(){}" >
              <option value="default">Escolha um tipo</option>
              <option
                v-for="qt in questionTypes"
                v-bind:key="qt.id"
                v-bind:value="qt.id"
              >{{qt.name}}</option>
            </select>
            <br>
          </div>

            <div>
              <textarea v-model="questionEdit.text" v-if="questionEdit.type != 'default' && questionEdit.type != undefined" style="width:100%; margin-top: 10px" rows="5" class="input-large"></textarea>

              <div
                class="modules-content"
                style="overflow-y: scroll;padding-right:0px;padding-left:0px;"
                v-if="questionEdit.type == 0 || questionEdit.type == 1"
              >
              
                <div class="module-item">
                  
                  <ul class="lessons-list">
                    <li class="lesson-subtitle custom-grid-modal-2">
                      <span class="lesson-title">Certa</span>
                      <span class="lesson-title">Ordem</span>
                      <span class="lesson-title">Resposta</span>
                      <span class="lesson-option">
                        <button @click="addAnswer()" class="btn btn-success">
                          Adicionar Resposta
                          <i class="fa fa-plus"></i>
                        </button>
                      </span>
                    </li>
                    
                    <draggable
                      style="max-height:250px;overflow-y:scroll;"
                      :key="listKey"
                      v-model="questionEdit.answers"
                      group="people"
                      @start="drag=true"
                      @end="testDragAnswer(questionEdit.answers)"
                    >
                      <div v-for="(a, index) in questionEdit.answers" :key="a.id">
                        <li v-if="!a.isDeleted" class="lesson custom-grid-modal-2">
                          <input type="checkbox" v-model="a.isCorrect" class="lesson-title" />
                          <span class="lesson-title">{{index}}</span>
                          <textarea
                            v-model="a.text"
                            style="width:100%"
                            rows="2"
                            class="lesson-title"
                          ></textarea>
                          <span class="lesson-option">
                            <button @click="removeAnswer(a)" class="btn btn-danger">
                              Remover
                              <i class="fa fa-trash"></i>
                            </button>
                          </span>
                        </li>
                      </div>
                    </draggable>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div
            v-else
            class="modules-content"
            style="overflow-y: scroll;padding-right:0px;padding-left:0px;"
          >
            <div class="module-item">
              <ul class="lessons-list">
                <li class="lesson-subtitle custom-grid-modal">
                  <span class="lesson-title">Numeração</span>
                  <span class="lesson-title">Questão</span>
                  <span class="lesson-title">Tipo</span>
                  <span class="lesson-option"></span>
                  <span class="lesson-option">
                    <button @click="editQuestion({})" class="btn btn-success">
                      Adicionar Pergunta
                      <i class="fa fa-plus"></i>
                    </button>
                  </span>
                </li>

                <button @click="editQuestion({})" class="btn btn-success btn-add-custom">
                      Adicionar
                      <i class="fa fa-plus"></i>
                    </button>

                <draggable
                  style="max-height:320px;overflow-y:scroll;"
                  :key="listKey"
                  v-model="questions"
                  group="people"
                  @start="drag=true"
                  @end="testDrag()"
                >
                  <div v-for="q in questions" :key="q.id">
                    <li v-if="!q.isDeleted" class="lesson custom-grid-modal">
                      <span class="lesson-title">{{q.order}}</span>
                      <span class="lesson-title">{{q.text}}</span>
                      <span class="lesson-title">{{q.type}}</span>
                      <span class="lesson-option">
                        <button @click="editQuestion(q)" class="btn btn-info">
                          Editar
                          <i class="fa fa-edit"></i>
                        </button>
                      </span>
                      <span class="lesson-option">
                        <button @click="removeQuestion(q)" class="btn btn-danger">
                          Remover
                          <i class="fa fa-trash"></i>
                        </button>
                      </span>
                    </li>
                  </div>
                </draggable>
              </ul>
            </div>
          </div>
        </transition>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
.v-leave {
  opacity: 1;
}
.v-leave-active {
  transition: opacity 2s;
}
.v-leave-to {
  opacity: 0;
}
.v-enter {
  opacity: 0;
}
.v-enter-active {
  transition: opacity 2s;
}
.v-enter-to {
  opacity: 1;
}

input[type="text"],
input[type="date"],
input[type="datetime"],
input[type="number"],
input[type="search"],
input[type="time"],
input[type="url"],
input[type="email"],
textarea,
select {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  border: 1px solid #bebebe;
  padding: 7px;
  margin: 0px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  outline: none;
}
input[type="text"]:focus,
input[type="date"]:focus,
input[type="datetime"]:focus,
input[type="number"]:focus,
input[type="search"]:focus,
input[type="time"]:focus,
input[type="url"]:focus,
input[type="email"]:focus,
textarea:focus,
select:focus {
  -moz-box-shadow: 0 0 8px #88d5e9;
  -webkit-box-shadow: 0 0 8px #88d5e9;
  box-shadow: 0 0 8px #88d5e9;
  border: 1px solid #88d5e9;
}

.custom-grid-modal-2 {
  grid-template-columns: 0.3fr 0.3fr 1.5fr 0.3fr !important;
}

.custom-grid-modal {
  grid-template-columns: 0.3fr 1fr 0.3fr 0.3fr 0.3fr !important;

  @media (max-width: 768px) {
    grid-template-columns: 1fr !important;
  }
}
.btn-add-custom {
  

  @media (min-width: 768px) {
    display: none;
  }
}

.li-custom {
  grid-template-columns: 0.75fr 0.75fr 0.75fr 1fr 1fr 0.75fr !important;
}

a.disabled {
  pointer-events: none;
  cursor: default;
}
.has-error {
  border-color: #a94442;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
}
</style>


<script>
import axios from "axios";
let config = require("../../../const.json");

axios.defaults.withCredentials = true;

export default {
  props: ["quiz"],
  data() {
    return {
      questionTypes: config.quiz.questionTypes,
      questionEdit: null,
      selectedModule: {},
      listKey: 0,
      course: this.$store.getters.course,
      savingQuiz: false,
      addNewQuiz: false,
      unlimited: false,
      newCoupon: {},
      addNew: false,
      modules: [],
      questions: []
    };
  },
  methods: {
    saveQuestion() {
      console.log(JSON.stringify(this.questionEdit));
      if (this.questionEdit.order == undefined) {
        let maxOrder = Math.max.apply(
          Math,
          this.questions.map(function(o) {
            return o.order;
          })
        );
        if (maxOrder == -Infinity) {
          maxOrder = 0;
        } else {
          maxOrder += 1;
        }
        this.questionEdit.order = maxOrder;
        this.questions.push(this.questionEdit);
      } else {
      }
      this.questionEdit = null;
    },
    addQuestion() {
      this.questions.push({ isDeleted: false });
    },
    removeAnswer(answer) {
      answer.isDeleted = true;
      this.listKey += 1;
    },
    addAnswer() {
      if (!this.questionEdit.answers) this.questionEdit.answers = [];

      let maxOrder = Math.max.apply(
        Math,
        this.questionEdit.answers.map(function(o) {
          return o.order;
        })
      );
      if (maxOrder == -Infinity) {
        maxOrder = 0;
      } else {
        maxOrder += 1;
      }

      this.questionEdit.answers.push({
        order: maxOrder,
        isCorrect: false,
        isDeleted: false
      });
      this.listKey += 1;
    },
    editQuestion(question) {
      if (question.isDeleted == undefined || question.isDeleted == null) {
        question.isDeleted = false;
      }
      console.log(question);
      this.questionEdit = question;
    },
    testDragAnswer(answers) {
      this.listKey += 1;
      console.log(answers);
      console.log("test drag");
    },
    testDrag() {
      this.listKey += 1;
      console.log();
      console.log("test drag");
    },
    removeQuestion(question) {
      question.isDeleted = true;
      this.listKey += 1;
    },
    changeUnlimited(value) {
      console.log(value);
    },
    save() {
      this.savingQuiz = true;
      const path = this.$global.endpoint + "/quiz/save";
      axios
        .post(path, {
          quiz: this.quiz,
          questions: this.questions
        })
        .then(res => {
          this.savingQuiz = false;
          this.$store.dispatch("loadQuizList", this.course.id);
          this.$emit("close");
        })
        .catch(error => {
          console.error(error);
        });
    },
    close() {
      this.$emit("close");
    },
    getModules() {
      const path = this.$global.endpoint + "/module/getall";
      axios
        .post(path, { courseId: this.course.id })
        .then(res => {
          this.modules = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    },
    getQuestions() {
      const path = this.$global.endpoint + "/quiz/question/getall";
      axios
        .post(path, { quizId: this.quiz.id })
        .then(res => {
          this.questions = res.data;
        })
        .catch(error => {
          console.error(error);
        });
    }
  },
  created() {
    if (this.quiz) {
      this.getQuestions();
    } else {
      this.quiz = {};
      this.quiz.title = "Avaliação";
    }
    this.getModules();
  }
};

function teste(){
    console.log("event");
  }
</script>
